<template>
    <div id="productionPlanView" class="production-plan-edit">
        <el-card class="table_searchbar" style="height: 830px;">
            
            <el-row style="margin-top: 10px;">
                <span class="label">订单号：</span>
                <span class="value" style="width:210px">{{(selectedSplit.productionOrderCode||selectedSplit.erpBusinessOrderCode)?selectedSplit.productionOrderCode||selectedSplit.erpBusinessOrderCode:selectedSplit.orderCode}}</span>

                <span class="label">工单号：</span>
                <span class="value" style="width:210px">{{selectedSplit.productionBatchCode}}</span>

                <span class="label" v-if="selectedSplit.childProductionBatchCode">子工单号：</span>
                <span class="value" v-if="selectedSplit.childProductionBatchCode">{{selectedSplit.childProductionBatchCode}}</span>

                <span class="label">生产数量：</span>
                <span class="value" style="width: 210px;">{{productionNum}} {{unitType}}</span>
            </el-row>
            <el-row style="margin-top: 10px;">
                <span class="label">物料编码：</span>
                <span :title="showMaterialCode?showMaterialCode:'&nbsp;'" class="value">{{showMaterialCode?showMaterialCode:'&nbsp;'}}</span>

                <span class="label">物料名称：</span>
                <span :title="showMaterialName?showMaterialName:'&nbsp;'" class="value">{{showMaterialName?showMaterialName:'&nbsp;'}}</span>

                <span class="label">物料型号：</span>
                <span :title="showMaterialModel?showMaterialModel:'&nbsp;'" class="value" >{{showMaterialModel?showMaterialModel:'&nbsp;'}}</span>

                <span class="label">物料类型：</span>
                <span class="value" >{{showMaterialType?showMaterialType:'&nbsp;'}}</span>

            </el-row>

            <el-row :gutter="0" style="display: flex;margin-top: 10px;margin-bottom: 10px;">
                <span class="label">计划时间：</span>
                <span style="width:80px;line-height: 32px;font-size:12px" >
                    {{allStartTime}}
                </span>
                <span style="padding: 0 10px;"><span style="padding-top: 6px;display: block;text-align: center;">—</span></span>
                <span style="width:80px;line-height: 32px;font-size:12px;margin-left: 10px;">
                    {{allEndTime}}
                </span>
                <span class="label">订单交付日期：</span>
                <span class="value">{{deliverTime?deliverTime:'&nbsp;'}}</span>
            </el-row>

            <el-row>
                <el-row>
                    <el-row>
                        <el-table class="plan_table" :data="preProductionPlanList" max-height="560" row-key="planId" stripe>
                            <el-table-column type="index" width='55' label="序号">
                                <template slot-scope="scope">
                                    {{scope.$index+1}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="procedureName" label="工序名称" show-overflow-tooltip min-width='80'></el-table-column>
                            <el-table-column prop="workCenterName" label="工作中心" show-overflow-tooltip min-width='90'></el-table-column>
                            <el-table-column prop="productionDateTime" label="计划生产时间" :min-width='W?240:260'>
                                <template slot-scope="scope" ref='timedata'>
                                    <el-row :gutter="0">
                                        <el-col :span="W?22:23">
                                            <el-date-picker type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" style="width:auto" popper-class='time_picker' format="yyyy/MM/dd HH" size="small" v-model="scope.row.planTime"  placeholder="开始日期" align="right" 
                                                :disabled="isDisabled2(scope.row)"></el-date-picker>
                                        </el-col>
                                    </el-row>
                                </template>
                            </el-table-column>
                            <el-table-column prop="workerName" label="剩余计划数量" :min-width='W?60:66'>
                                <template slot-scope="scope">
                                    <span>{{scope.row.remainingQuantity }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="workerName" label="" :min-width='W?55:66'>
                                <template slot-scope="scope">
                                    <el-button type="text"  @click="addSplit(scope.row,scope.$index)" size="small">添加执行组</el-button>
                                </template>
                            </el-table-column>
                            
                            <el-table-column prop="workerName" label="执行者+设备+生产数量" :min-width='W?320:330'>
                                <template slot="header" >
                                    <span>执行者+设备+生产数量</span>
                                    <el-tooltip class="item" effect="dark" content="执行者最多显示50名员工，若菜单中找不到该员工，建议通过输入名字的方式检索" placement="top">
                                        <span class="help"></span>
                                    </el-tooltip>
                                </template>
                                <template slot-scope="scope">
                                    <div>
                                        <el-row v-for="(planItem,index) in scope.row.groupList" :key="index" :style="index!=0?{marginTop:'10px'}:{}">
                                            <el-col :span="6" style="margin-left:6px">
                                                <el-select v-model="planItem.workerId" :class="{redBorder:(Number(planItem.unFinishedCount)>0||planItem.workerTips)}" @visible-change="workerBlur($event,scope.row,index,'worker')" placeholder="执行人" clearable remote filterable
                                                    :remote-method="remoteMethod1" :loading="loading" @change="selectWorkerChange($event,scope,index)" no-data-text='暂无员工' @focus="changeIndex(scope.$index,1,index)" :disabled="isDisabled(scope.row)||(planItem.updateFlag>0)">
                                                    <span v-if='scope.row.workerSelect[index]&&scope.row.workerSelect[index].length==0' style="padding-left: 20px;font-size: 12px;color: red;line-height: 30px;">暂无员工</span>
                                                    <el-option v-for="item in scope.row.workerSelect[index]" :key="item.id" :label="item.label" :value="item.id" :title="item.label">
                                                        <div :class="{redText:Number(item.unFinishedCount)>0}" :style="showWorkStyle">{{item.label}}</div>
                                                        <div :class="{redText:Number(item.unFinishedCount)>0}" style="float:right;width:50px;text-align: right">{{item.unFinishedCount}}</div>
                                                    </el-option>
                                                </el-select>
                                            </el-col>
                                            <el-col :span="10" style="margin-left:6px">
                                                <el-select  v-model="planItem.deviceId" :class="{redBorder:(Number(planItem.operationRatio)>1||planItem.deviceTips)}" popper-class='select_width1' clearable @visible-change="deviceBlur($event,scope.row,index)" remote filterable
                                                    :remote-method="remoteMethod" :loading="loading" @focus="changeIndex(scope.$index,1,index)" placeholder="设备" @change="selectDeviceChange($event, scope,index)" :disabled="isDisabled(scope.row)||(planItem.updateFlag>0)">
                                                    <el-option-group v-for="group in scope.row.deviceSelect[index]" :key="group.label" :label="group.label">
                                                        <span v-if='group.deviceList.length==0' style="padding-left: 20px;font-size: 12px;color: red;line-height: 30px;">暂无常用设备</span>
                                                        <el-option v-else :title="item.deviceCode+'|'+item.label" v-for="item in group.deviceList" :key="item.id" :label="item.operationRatio?`${item.deviceCode}|${item.label} ${item.operationRatio}`:`${item.deviceCode}|${item.label}`" :value="item.id">
                                                            <div :class="{redText:Number(item.operationRatio)>1}" :style="showDeviceStyle">{{item.deviceCode}}|{{item.label}}</div>
                                                            <!-- <div :class="{redText:Number(item.operationRatio)>1}" style="float:right;width:50px;text-align: right">{{Math.round(item.operationRatio*100)}}%</div> -->
                                                        </el-option>
                                                    </el-option-group>
                                                </el-select>
                                            </el-col>
                                            <el-col :span="4" style="margin-left:6px" class="amount-input">
                                                <el-input :class="{redInput:planItem.unPass}" @input="productionInput(scope.$index,scope.row.groupList,index)" v-model="planItem.executeCount" :disabled="isDisabled(scope.row)||planItem.updateFlag==2"></el-input>
                                            </el-col>
                                            <el-col :span='2' style="margin-left:6px">
                                                <el-button type="text" @click="deleteItem(scope.row,index,scope.$index)" :disabled="isDisabled(scope.row)||(planItem.updateFlag==2)" v-if="scope.row.groupList.length!=1&&(planItem.updateFlag==0)" size="small">删除</el-button>
                                            </el-col>
                                        </el-row>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="actualFinishedAmount" label="有效生产数量" :min-width='W?80:90' >
                                <template slot-scope="scope">
                                    <div>
                                        <el-row v-for="(planItem,index) in scope.row.groupList" :key="index" :style="index!=0?{marginTop:'10px'}:{}">
                                            <el-col :span="24" >
                                                <span style="line-height: 32px;">&nbsp; {{planItem.actualFinishedAmount?planItem.actualFinishedAmount:'—'}}</span>
                                            </el-col>
                                        </el-row>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="actualUnqualifiedProcessCount" label="不合格数量" :min-width='W?80:90' >
                                <template slot-scope="scope">
                                    <div>
                                        <el-row v-for="(planItem,index) in scope.row.groupList" :key="index" :style="index!=0?{marginTop:'10px'}:{}">
                                            <el-col :span="24" >
                                                <span style="line-height: 32px;">&nbsp; {{planItem.actualUnqualifiedProcessCount?planItem.actualUnqualifiedProcessCount:'—'}}</span>
                                            </el-col>
                                        </el-row>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="actualSpoiledProcessCount" label="报废数量" :min-width='W?80:90' >
                                <template slot-scope="scope">
                                    <div>
                                        <el-row v-for="(planItem,index) in scope.row.groupList" :key="index" :style="index!=0?{marginTop:'10px'}:{}">
                                            <el-col :span="24" >
                                                <span style="line-height: 32px;">&nbsp; {{planItem.actualSpoiledProcessCount?planItem.actualSpoiledProcessCount:'—'}}</span>
                                            </el-col>
                                        </el-row>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="theoreticalTime" label="理论时间(s)" :min-width='W?90:90' >
                                <template slot-scope="scope">
                                    <div>
                                        <el-row v-for="(planItem,index) in scope.row.groupList" :key="index" :style="index!=0?{marginTop:'10px'}:{}">
                                            <el-col :span="24" >
                                                <span style="line-height: 32px;">&nbsp; {{parseRunTime(planItem)}}</span>
                                            </el-col>
                                        </el-row>
                                    </div>
                                </template>
                            </el-table-column>

                            <el-table-column prop="remark" label="备注" min-width='100'>
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.remark" :disabled="isDisabled2(scope.row)"></el-input>
                                </template>
                            </el-table-column>

                            <el-table-column prop="remark" label="是否报工" :min-width='W?52:55'>
                                <template slot-scope="scope">
                                    <el-checkbox @change="needReportStatusChange($event,scope.row)" v-model="scope.row.isNeedReport" :disabled="isDisabled2(scope.row)||cancalSelect(scope.$index,scope.row)"></el-checkbox>
                                </template>
                            </el-table-column>

                        </el-table>
                    </el-row>
                    <div :style="W?{textAlign: 'center',marginTop: '10px',}:{textAlign: 'center',marginTop: '10px',marginBottom:'30px'}">
                        <el-button type="primary" icon="el-icon-arrow-left" size="small" @click="backToOrderItemView">返回</el-button>
                        <el-button :disabled="selectedSplit.splitStatus!=1" v-if="!arrangeComplete" type="primary" @click="reSetPlan(1)">重置</el-button>
                        <el-button v-if="!arrangeComplete" type="primary" @click="submitProductionPlan(1)">保存</el-button>
                        <el-button type="primary" @click="submitProductionPlan(2)">提交并下达</el-button>
                    </div>
                </el-row>
            </el-row>
        </el-card>
    </div>
</template>

<script>

import pinyinMatch from 'pinyin-match'
import dayjs from 'dayjs'
export default {
    name: 'productionPlanView',
    props: {
        selectedSplit: Object,
    },
 
    data() {
        return {
            isReload:false,
            technologyId:null,
            splitId:null,
            orderCode:'',
            arrangeComplete:false, //显示保存按钮
            unitType: '',
            needStockAmount: 0,
            showTimeChange: true,
            btnTrue: '',
            btnFalse: '',
            splitType: null,
            allStartTime: this.selectedSplit.planStartTime?dayjs(this.selectedSplit.planStartTime).format('YYYY/MM/DD'):"",
            allEndTime: this.selectedSplit.planEndTime?dayjs(this.selectedSplit.planEndTime).format('YYYY/MM/DD'):'',
            type: null,
            index: null,
            loading: false,
            W: false,
            dIndex: 0,
            oderType: 0,
            productionType: 0,
            preProductionPlanList: [],//生成计划预安排
            deviceSelect: [],//可用设备
            workerSelect: [],//可用工人
            productionNum: 0,
            workershopList: [],
            allWorkerSelect: [{},{deviceList:[]}],
            allDeviceList: [],
            deliverTime:'',
            fristEdit: true,  //默认第一次编排任务
            permission: JSON.parse(localStorage.getItem("permission")),
        }
    },

    beforeMount: async function () {
        this.productionType = this.selectedSplit.productionType||0;
        this.productionNum = this.selectedSplit.splitCount;
        this.deliverTime = this.selectedSplit.deliverTime?dayjs(this.selectedSplit.deliverTime).format('YYYY/MM/DD'):'-'
        this.orderCode = this.selectedSplit.orderCode||''
        this.splitId = this.selectedSplit.splitItemId
        this.loadBaseData()
        this.listPreProductionPlan();

    },

    //完成挂载
    mounted: function () {
        let w = document.documentElement.clientWidth || document.body.clientWidth;
        w >= 1900 ? this.W = true : this.W = false
        let data = this.selectedSplit
        this.oderType = data.splitItemType
        this.spselectedSplitData = this.selectedSplit
        this.needStockAmount = this.selectedSplit.needStockAmount
        this.unitType = data.unitType || ''
    },

    //更新dom时触发

    computed: {
        showDeviceStyle() {
            if (this.W) {
                return { float: 'left', width: '150px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }
            } else {
                return { float: 'left', width: '100px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }
            }
        },
        showWorkStyle() {
            if (this.W) {
                return { float: 'left', width: '80px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }
            } else {
                return { float: 'left', width: '60px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }
            }
        },

        showMaterialName(){
			let data = this.selectedSplit;
			return data.materialName||'';
		},

		showMaterialCode(){
			let data = this.selectedSplit;
			return data.materialCode||'';
		},

		showMaterialModel(){
			let data = this.selectedSplit;
			return data.specification||'';
		},

        showMaterialType(){
            let data = this.selectedSplit;
			let str = "";
			if(data != null){
				if(data.splitItemType==1){
					str = '零件'
				}else{
					str = '产品'
				}
			}
			return str;
        },
    },

    methods: {

        // 获取编排任务数据
        // 1.
        listPreProductionPlan(isAsc) {
            this.$RequestUtil.loading()
            return new Promise((resolve, reject) => {
                this.$RequestUtil.post({
                    url: '/api/productionPlan/v2/listPreProductionPlan',
                    params: {
                        splitId: this.selectedSplit.splitItemId,
                        materialId: this.selectedSplit.materialId,
                        productionType: this.productionType,
                        tecId: this.selectedSplit.tecId,
                        isAsc
                    },
                    success: async res => {
                        if (res.code != 0) {
                            this.$message.error(res.message);
                            this.$RequestUtil.loading().close()
                            reject();
                            return;
                        }
                        this.arrangeComplete = res.data.arrangeComplete
                        let arr = res.data.procedureList;
                        //默认是第一次编排任务
                        this.fristEdit = true
                        for (let i = 0; i < arr.length; i++) {
                            let item = arr[i]
                            //兼容groupList不为空
                            if (!item.groupList) {
                                item.groupList = [{ updateFlag: 0 }]
                            }
                            item.deviceSelect = []
                            item.workerSelect = []
                            if (item.groupList.length > 0) {
                                item.groupList.forEach(async (p, j) => {
                                   
                                    let deviceData = commonUtils.cloneObj(this.allDeviceList)
                                    if(p.deviceId){
                                        let has = this.allDeviceList[1].deviceList.find(f=>f.id==p.deviceId)
                                        if(!has){
                                            deviceData[1].deviceList.unshift({
                                                id:p.deviceId,
                                                deviceCode:p.deviceCode||' ',
                                                label:p.deviceName||' ',
                                                operationRatio:null
                                            })
                                        }
                                    }
                                    this.checkExecuteCount(p)
                                    this.$set(item.deviceSelect, j, deviceData)
                                    let workerData = commonUtils.cloneObj(this.allWorkerSelect)
                                    if (p.workerId) {
                                        let has = this.allWorkerSelect.find(f=>f.id==p.workerId)
                                        if(!has){
                                            workerData.unshift({
                                                id:p.workerId,
                                                label:p.workerName
                                            })
                                        }
                                    } 
                                    this.$set(item.workerSelect, j, workerData)  
                                })
                            }

                            if(item.groupList.every(g=>g.updateFlag==2)){
                                item.updateFlag = 2
                                this.fristEdit = false
                            }
                            if(item.groupList.some(g=>g.updateFlag==1)){
                                item.updateFlag = 1
                            }
                            item.planTime = []
                            // 已安排生产计划
                            if(item.planStartTime&&item.planEndTime){
                                item.planTime = [item.planStartTime,item.planEndTime]
                            }
                            
                            //加载待选这设备和工人
                            // 计算
                            this.getTheoreticalTime(item)
                            item.remainingQuantity = this.getRemainingQuantity(item.groupList)

                        }
                        this.$RequestUtil.loading().close()
                        this.preProductionPlanList = arr
                        resolve();
                    }
                });
            });
        },

        // 计算理论时间
        getTheoreticalTime(rowData){
            rowData.groupList.forEach(item=>{
                if(item.executeCount&&item.productionCycle){
                    item.theoreticalTime = Math.floor(item.executeCount * item.productionCycle)
                }else{
                    item.theoreticalTime = ''
                }
            })
        },

        // 获取剩余计划数量
        getRemainingQuantity(groupList){
            let remainingQuantity = 0
            let TotalNum = 0
            groupList.forEach(g=>{
                TotalNum+= Number(g.executeCount)||0
            })
            remainingQuantity = Math.round((this.productionNum - TotalNum)*100)/100
            return remainingQuantity
        },

        // 1.初始化加载默认50条设备数据和用户数据
        loadBaseData() {
           this.$RequestUtil.post({
                url: '/api/select/productionAssignableDevice',
                params: { arrangedDevice: [], startDate: null, endDate: null, deviceType: null, deviceId: null, },
                success: res => {
                    if(res.code==0){
                        this.allDeviceList = res.data
                    }
                }
            })
            this.$RequestUtil.post({
                url: '/api/select/listWorker',
                params: { limitCount: 50, },
                success: res => {
                    if(res.code==0){
                        this.allWorkerSelect = res.data
                    }
                }
            });
        },

        parseRunTime(rowData) {
            if (rowData.theoreticalTime) {
                return commonUtils.secondToDate(rowData.theoreticalTime)
            } else {
                return '—'
            }
        },

        // 是否报工
        cancalSelect(index,row) {
            if (index == 0 || index == this.preProductionPlanList.length - 1) {
                return true
            } else {
                if(this.selectedSplit.splitStatus==2||this.selectedSplit.splitStatus==3){
                    return true
                }
                if(row.groupList){
                    return row.groupList.some(item=>item.planState>0&&item.planState!=3)
                }
                
                return false
            }
        },

        hasNeedReport(rowData) {
            return !rowData.isNeedReport
        },

        // 多执行勾选不需要报工后删除多执行组
        needReportStatusChange(ev, rowData) {
            if (ev == false && rowData.groupList.length > 1) {
                this.$confirm('多执行组取消报工后将会删除多执行组数据，是否继续?', '提示', {
                    cancelButtonClass: "btn-custom-cancel",
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then((res) => {
                    let item = rowData.groupList[0]
                    item.executeCount = this.productionNum

                    this.$set(rowData, 'groupList', [item])
                }).catch((err) => {
                    this.$set(rowData, 'isNeedReport', true)
                })
            }
        },

     
        // 修改执行组数量校验数量是否小于报工数量
        productionInput(ev, groupList, index) {
            let len = (String(groupList[index].executeCount).split('.')[1] || '').length
            let executeCount = Number(groupList[index].executeCount)
            if (len > 2) {
                executeCount = Number(executeCount.toFixed(2))
                groupList[index].executeCount = executeCount
            }
            this.checkExecuteCount(groupList[index])
            this.preProductionPlanList[ev].remainingQuantity = this.getRemainingQuantity(groupList)
            this.getTheoreticalTime(this.preProductionPlanList[ev])
            this.$set(this.preProductionPlanList[ev], 'groupList', groupList)
        },

        checkExecuteCount(row){
            if(row.actualFinishedAmount&&row.planState!=1){
                let qualifiedProcessCount = row.actualFinishedAmount+Number(row.actualUnqualifiedProcessCount)

                if (row.executeCount && row.executeCount < qualifiedProcessCount) {
                    row.unPass = true
                } else {
                    row.unPass = false
                }
            }
        },



        // 删除执行组报工数量逻辑暂不修改
        deleteItem(rowData, index, index1) {
            rowData.groupList.splice(index, 1)
            rowData.deviceSelect.splice(index, 1)
            rowData.workerSelect.splice(index, 1)
            rowData.remainingQuantity = this.getRemainingQuantity(rowData.groupList)
        },

        // 添加执行组
        // 1.添加默认基础数量 报工状态  报工数量
        // 2.填充设备和用户下拉列表
        async addSplit(rowData, index) {
            let len = rowData.groupList.length
            rowData.groupList.push({
                updateFlag: 0,
                executeCount: 0,
                productionCycle:rowData.groupList[0].productionCycle
            })
            if (rowData.deviceType || rowData.planStartTime || rowData.planEndTime) {
                let { data } = await this.loadPrduction('', '', '', rowData.deviceType, rowData.planStartTime, rowData.planEndTime)
                this.$set(rowData.deviceSelect, len, data)
            } else {
                this.$set(rowData.deviceSelect, len, this.allDeviceList)
            }
            this.$set(rowData.workerSelect, len, this.allWorkerSelect)
            
            this.$set(this.preProductionPlanList, index, rowData)
        },

        keepTwoDecimal(n) {
            n = Number(n)
            return Math.round(n * 100) / 100
        },

        changeIndex(index, type, dIndex) {
            this.index = index
            this.type = type
            this.dIndex = dIndex
        },

        
        async deviceBlur(ev, rowData, index) {
            if (!ev) {
                let workerId = rowData.groupList[index].workerId
                let deviceId = rowData.groupList[index].deviceId
                let groupId = rowData.groupList[index].groupId
                let { data } = await this.loadPrduction('', workerId, deviceId, rowData.deviceType, rowData.planStartTime, rowData.planEndTime, groupId)
                this.$set(rowData.deviceSelect, index, data)
            } else {
                if (rowData.deviceSelect[index][0].deviceList.length == 0 && rowData.deviceSelect[index][1].deviceList.length == 0) {
                    this.$message.warning('当前设备列表暂无数据')
                }
            }
        },

        // 模糊查询设备数据
        async remoteMethod(query) {
            this.loading = true;
            let workerId = this.preProductionPlanList[this.index].groupList[this.dIndex].workerId
            let deviceId = this.preProductionPlanList[this.index].groupList[this.dIndex].deviceId
            let groupId = this.preProductionPlanList[this.index].groupList[this.dIndex].groupId
            let planStartTime = this.preProductionPlanList[this.index].planStartTime
            let planEndTime = this.preProductionPlanList[this.index].planEndTime
            let deviceType = this.preProductionPlanList[this.index].deviceType
            let { data } = await this.loadPrduction(query, workerId, deviceId, deviceType, planStartTime, planEndTime, groupId)
            this.$set(this.preProductionPlanList[this.index].deviceSelect, this.dIndex, data)
            this.loading = false
        },

        // 模糊查询用户数据
        async remoteMethod1(query) {
            this.loading = true;
            let workerId = this.preProductionPlanList[this.index].groupList[this.dIndex].workerId
            let groupId = this.preProductionPlanList[this.index].groupList[this.dIndex].groupId
            let data = await this.loadAllWorkerSelect(query, workerId, groupId)
            this.$set(this.preProductionPlanList[this.index].workerSelect, this.dIndex, data)
            this.loading = false
        },

        async loadPrduction(searchText, userId, deviceId, deviceType, planStartTime, planEndTime, groupId) {
            return await this.$RequestUtil.postAsync({ url: '/api/select/productionAssignableDevice', params: { searchText, userId, deviceId, deviceType, planStartTime, planEndTime, groupId } })
        },


        isDisabled2(row) {
            let flag = false;
            if (row.planId != null && !row.editing) {
                flag = true;
            }
            if(row.groupList.some(item=>item.planState==1)){
                flag = true;
            }
            return flag;
        },

  

        isDisabled(row) {
            let flag = false;
            if ((row.planId != null && !row.editing)) {
                flag = true;
            }
            return flag;
        },

        submit(type) {
            let data = JSON.parse(JSON.stringify(this.preProductionPlanList));
            
            data.forEach(item=>{
                if(item.planTime&&item.planTime.length==2){
                    item.planStartTime = item.planTime[0]
                    item.planEndTime = item.planTime[1]
                }
            })
            if (this.btnFalse) {
                if (data[0].planStartTime) {
                    let start = new Date(data[0].planStartTime).getTime()
                    if (start < new Date().getTime()) {
                        this.$message.warning('排程不满足交期')
                    }
                }
            } else {
                let deliverTime = this.selectedSplit.planEndTime || this.selectedSplit.deliverTime
                if (data[data.length - 1].planEndTime) {
                    let planEndTime = new Date(data[data.length - 1].planEndTime).getTime()
                    if (deliverTime && planEndTime > deliverTime) {
                        this.$message.warning('排程不满足交期')
                    }
                }
            }

            let submitData = [];
            //默认是提交当有未编排的工序时未保存
            let arrangeComplete = true
            for (let i = 0; i < data.length; i++) {
                let item = data[i];
                // 去除select
                delete item.deviceSelect;
                delete item.workerSelect;
                delete item.productionDateTime;
                submitData.push(item);
            }
        

            //检测有没有选择工人和设备和时间
            let checkProductionNum = true
            let allSelect = true
            for (let i = 0; i < data.length; i++) {
                let item = data[i]
                if(item.remainingQuantity!=0){
                    this.$message.error({
                        type: 'error',
                        message: `第${i + 1}道工序编排任务生产数量不等于订单生产数量`
                    })
                    checkProductionNum = false
                    break
                }
                if(!item.planTime){
                    item.planStartTime = ''
                    item.planEndTime = ''
                }
                for (let index = 0; index < item.groupList.length; index++) {
                    const planItem = item.groupList[index]
                    delete planItem.deviceTypeId
                    planItem.planStartTime = item.planStartTime
                    planItem.planEndTime = item.planEndTime
                    planItem.executeCount = Number(planItem.executeCount)
                    planItem.isNeedReport = item.isNeedReport
				
                    //当工序无法编辑不去校验生产任务数量
                    if (isNaN(planItem.executeCount) || planItem.executeCount <= 0) {
                        this.$message.error({
                            type: 'error',
                            message: `第${i + 1}道工序第${index + 1}个任务生产数量必须大于零`
                        })
                        checkProductionNum = false
                        break
                    }
                    if (planItem.unPass) {
                        this.$message.error({
                            type: 'error',
                            message: `第${i + 1}道工序第${index + 1}个任务生产数量不能小于报工数量(有效数量+不合格数量)`
                        })
                        checkProductionNum = false
                    }
                    

                    //当groupId 存在  workerId 和deviceId需要同时存在或者同时不存在
                    if ((!planItem.workerId && !planItem.deviceId)) {
                        this.$message.error({
                            type: 'error',
                            duration: 3000 + i * 1000,
                            offset: 20 + i * 50,
                            message: `第${i + 1}道工序第${index + 1}个任务组执行人和设备不能同时为空`
                        })
                        allSelect = false
                        break
                    }
                }
            }

            if (!checkProductionNum) {
                return
            }

            if (!allSelect) {
                return
            }
			
            if (type == 1) {
                arrangeComplete = false
            } 

            this.$RequestUtil.post({
                url: '/api/productionPlan/createProductionPlan',
                params: {
                    procedureDataList: submitData,
                    splitId: this.selectedSplit.splitItemId,
                    productionType: this.productionType,
                    arrangeComplete: arrangeComplete,
                    tecId: this.selectedSplit.tecId,
                },
                type: 'sync',
                success: (res) => {
                    if (res.code != 0) {
                        this.$message.error(res.message);
                        return;
                    }
                    if (arrangeComplete) {
                        this.$parent.reload()
                        this.$parent.showPage = 1;
                    }
                    let str = arrangeComplete ? '生产计划安排完成' : '生产计划保存成功'
                    this.$message.success(str);
                    if (type == 1) {
                        this.listPreProductionPlan();
                        this.selectedSplit.splitStatus=1
                        this.isReload = true
                    }
                    this.$store.commit('add_reloadPages', ["/Production"])
                }
            });
        },

        submitProductionPlan(type) {
            if (type == 2) {
                this.$confirm('是否提交当前编排任务?', '提示', {
                    cancelButtonClass: "btn-custom-cancel",
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }).then(
                    () => {
                        this.submit(type)
                    }
                )
            } else {
                this.submit(type)
            }
        },

        reSetPlan(){
            this.$confirm('是否要将当前编排任务全部清零?', '提示', {
                cancelButtonClass: "btn-custom-cancel",
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(
                ()=>{
                    this.$RequestUtil.post({
                        url: '/api/productionTask/resetSplit',
                        params: {
                            id: this.selectedSplit.splitItemId,
                        },
                        type: 'sync',
                        success: (res) => {
                            if(res.code==0){
                                this.listPreProductionPlan();
                                this.selectedSplit.splitStatus=6
                                this.$message.success('重置成功')
                            }else{
                                this.$message.error(res.msg||res.message)
                            }
                            
                        }
                    })
                }
            )
        },

        backToOrderItemView() {
            this.$parent.showPage = 1;
            this.$parent.backTecId = this.selectedSplit.tecId
            this.$parent.backItemId = this.selectedSplit.splitItemId
            if(this.isReload){
                this.$parent.search()
                this.isReload = false
            }
            
        },

        async workerBlur(ev, rowData, index, type) {
            if (!ev) {
                if (this.type == 2) {
                    let workerId = rowData.workerId
                    let groupId = rowData.groupId
                    let data = await this.loadAllWorkerSelect('', workerId, groupId)
                    this.allWorkerSelect = data

                    this.$set(this, 'allWorkerSelect', data)
                    this.loading = false
                } else {
                    let workerId = rowData.groupList[index].workerId
                    let groupId = rowData.groupList[index].groupId
                    let data = await this.loadAllWorkerSelect('', workerId, groupId)
                    if (type == 'group') {
                        if (data.length == 0) {
                            this.$message.warning('当前部门下暂无用户')
                        } else {
                            let find = data.find(f => f.isOrgLeader == true)
                            if (!find) {
                                this.$message.warning('该部门下无可用负责人')
                            }
                        }
                    }
                    this.$set(this.preProductionPlanList[this.index].workerSelect, index, data)
                    this.loading = false
                }
            } else {
                if (this.type == 2) {
                    if (this.allWorkerSelect.length == 0 && type == 'woker') {
                        this.$message.warning('员工列表暂无数据')
                    }
                } else {
                    if (rowData.workerSelect[index].length == 0 && type == 'worker') {
                        this.$message.warning('员工列表暂无数据')
                    }
                }
            }
        },

        async selectDeviceChange(val, scope, index) {

            let arr = scope.row.groupList
            if (!val) {
                let planStartTime = scope.row.planStartTime;
                let planEndTime = scope.row.planEndTime;
                arr[index].operationRatio = 0

                let { data } = await this.loadPrduction('', scope.row.groupList[index].workerId, scope.row.groupList[index].deviceId, scope.row.deviceType, planStartTime, planEndTime, scope.row.groupList[index].groupId)
                scope.row.deviceSelect[index] = data
            }
        },

        async selectWorkerChange(val, scope, index) {
            let arr = scope.row.groupList
            if (!val) {
                arr[index].unFinishedCount = 0
                arr[index].operationRatio = 0
                return
            }
            // if (arr[index].deviceId) {
            //     this.$set(arr[index], 'deviceId', null)
            //     arr[index].operationRatio = 0
            // }
            let planStartTime = scope.row.planStartTime;
            let planEndTime = scope.row.planEndTime;
            let { data } = await this.loadPrduction('', val, arr[index].deviceId, scope.row.deviceType, planStartTime, planEndTime, scope.row.groupId)
            this.$set(this.preProductionPlanList[scope.$index].deviceSelect, index, data)
        },

        async loadAllWorkerSelect(workerName = '', workerId, groupId) {
            let res = await this.$RequestUtil.getAsync({ url: '/api/select/listWorker', params: { workerName, workerId, groupId, limitCount: 50 }, });
            if (res.code == 0) {
                if (!workerName && !workerId && !groupId) {
                    this.allWorkerSelect = res.data;
                }
                return res.data
            }
        },

        async loadWorkShopList(procedureId,id,factoryModelName,factoryModelCode) {
            let res = await this.$RequestUtil.getAsync({ url: '/api/factoryModel/getWorkShopList',params: {itemType:this.selectedSplit.splitItemType,procedureId,id,factoryModelName,factoryModelCode},})
            if (res.code == 0) {
                return res.data
            }
        },

    },
    watch: {
        preProductionPlanList: {
            handler: function (newV) {
                newV.forEach((e, index) => {
                    e.groupList.forEach((p, indexP) => {
                        if (e.deviceSelect && e.deviceSelect[indexP]) {
                            (e.deviceSelect[indexP] || []).forEach((s) => {
                                (s.deviceList || []).forEach(d => {
                                    if (p.deviceId === d.id) {
                                        p.operationRatio = d.operationRatio
                                    }
                                })
                            })
                        }
                        if (e.workerSelect && e.workerSelect[indexP]) {
                            let find = e.workerSelect[indexP].find(w => w.id == p.workerId)
                            if (find) {
                                p.unFinishedCount = find.unFinishedCount
                            }

                        }
                    })
                })
            },
            deep: true
        }
    },
}
</script >

<style scoped>
.operateBtn-wrap {
    margin-top: 20px;
}
.label {
    display: inline-block;

    height: 32px;
    line-height: 32px;
    font-size: 12px;
    color: #606266;
}
.value {
    display: inline-block;
    width: 200px;
    line-height: 32px;
    font-size: 12px;
    color: #606266;
    vertical-align: top;
    word-break: break-all;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.help {
    background: url(/static/img/help.png);
    width: 17px;
    height: 17px;
    display: inline-block;
    background-size: cover;
    margin-left: 4px;
    position: relative;
    top: 4px;
}
.file-icon-container {
    width: 36px;
    height: 45px;
    margin-top: -17px;
    background-size: cover;
    position: relative;
    cursor: pointer;
}

.file-delete {
    position: absolute;
    top: -6px;
    left: 28px;
    width: 15px;
    height: 15px;
    background-image: URL("/static/img/delete.png");
    background-size: cover;
    cursor: pointer;
}
@media screen and (max-width: 1366px) {
    .value {
        width: 190px;
    }
    .file-icon-container {
        width: 27px;
        height: 36px;
        margin-top: -10px;
    }
}
@media screen and (max-width: 1280px) {
    .value {
        width: 166px;
    }
}
</style>


<style>
.value .el-input__inner {
    height: 28px;
    line-height: 28px;
}
.select_width {
    width: 139px;
}
.select_width1 {
    width: 250px;
}
.datetime_picker {
    vertical-align: middle;
}
.time_picker .el-time-spinner {
    overflow: hidden;
}
.time_picker .el-time-spinner__wrapper {
    width: 100%;
}
.time_picker .el-time-panel__footer {
    display: flex;
    justify-content: center;
}
.time_picker .el-time-panel {
    width: 150px;
}
.time_picker .el-input__inner {
    text-align: center;
}
.time_picker .el-time-spinner.has-seconds .el-time-spinner__wrapper {
    width: 100%;
}
#productionPlanView .value .el-input {
    width: 160px;
}
.plan_table .amount-input .el-input .el-input__inner {
    padding: 0px 4px;
}
@media screen and (max-width: 1440px) {
    .plan_table {
        max-height: 500px !important;
        overflow: auto;
    }
    .plan_table .el-table__body-wrapper {
        max-height: 400px !important;
        overflow-y: auto;
    }
}
@media screen and (max-width: 1366px) {
    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
        width: 146px !important;
    }
    #productionPlanView .value {
        width: 190px;
    }
    .value .el-input {
        width: 140px;
    }
    .file-icon-container {
        width: 27px;
        height: 36px;
        margin-top: -10px;
    }
}
@media screen and (max-width: 1280px) {
    .value {
        width: 166px;
    }
    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
        width: 140px !important;
    }
}
@media screen and (max-width: 2000px) and (min-width: 1441px) {
    .plan_table {
        max-height: 700px !important;
        overflow: auto;
    }
    .plan_table .el-table__body-wrapper {
        max-height: 600px !important;
        overflow-y: auto;
    }
}
.plan_table .el-select .el-input.is-disabled .el-input__inner {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.redText {
    color: red;
}
.redInput .el-input__inner {
    border: 1px solid red;
}
.redBorder input {
    border-color: red !important;
}
</style>



// WEBPACK FOOTER //
// src/views/order/ProductionTask/ProductionPlanEdit.vue